import useOnScreen from '@rio-cloud/rio-uikit/hooks/useOnScreen';
import { useRef } from 'react';

import { TRACKING_ACTIONS } from '#configuration/setup/googleAnalytics.ts';
import { useTrackScreenSeen } from '#hooks/useTrackScreenSeen.ts';

type NoDataViewProps = {
    title: string;
    message: string;
    link?: {
        href: string;
        label: string;
        icon?: string;
    };
    trackingCategory: string;
    trackingLabel: string;
};

export const NoDataView = ({ title, message, link, trackingCategory, trackingLabel }: NoDataViewProps) => {
    const ref = useRef(null);
    const onScreen = useOnScreen(ref);

    useTrackScreenSeen(onScreen, {
        category: trackingCategory,
        action: TRACKING_ACTIONS.ON_SCREEN,
        label: trackingLabel ?? 'Show no data view',
    });

    return (
        <div data-testid='no-data-view' className='display-flex justify-content-center max-width-100pct' ref={ref}>
            <div className='margin-0 width-100pct max-width-600 panel-default panel padding-15 border-none'>
                <div className='display-flex flex-column align-items-center text-center padding-25'>
                    <div className='text-size-h2 margin-bottom-20'>
                        <span className='uikit-icon icon-looking-glass-man text-color-light text-size-300pct' />
                    </div>
                    <div className='text-size-h3 text-size-h2-xl line-height-125rel text-color-dark text-medium width-500 max-width-100pct text-wrap-balance'>
                        {title}
                    </div>
                    <div className='text-color-dark margin-top-15 width-500 max-width-100pct text-wrap-balance'>
                        {message}
                    </div>
                    {link && (
                        <div className='margin-top-15'>
                            <a className='btn btn-primary' href={link.href} target='_blank' rel='noreferrer'>
                                {link.icon && <span className={`uikit-icon icon-${link.icon} margin-right-5`} />}
                                {link.label}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
